export default "__VITE_PUBLIC_ASSET__6bca16a3__"